import PropTypes from 'prop-types';

import dynamic from 'next/dynamic';
import Layout from '../../../components/common/Layout';
import { getServerSidePropsForImmobilien } from '../../../utils/page';
import { PROPERTY_REQUEST_MODE } from '../../../utils/constants';

const Properties = dynamic(import('../../../components/Properties'));
const SearchBox = dynamic(import('../../../components/common/SearchBox'));

const PropertiesPageHouseRent = (props) => {
  const { result } = props;
  const { title } = result;
  return (
    <Layout title={`Immobilien in ${title || ''} - wohnpreis.de`}>
      <SearchBox {...props} />
      <Properties {...props} />
    </Layout>
  );
};

export async function getServerSideProps(context) {
  // eslint-disable-next-line max-len
  const result = await getServerSidePropsForImmobilien(
    context,
    PROPERTY_REQUEST_MODE.RENT,
    PROPERTY_REQUEST_MODE.HOUSE,
  );
  return {
    props: { result },
  };
}

PropertiesPageHouseRent.propTypes = {
  result: PropTypes.object,
};

PropertiesPageHouseRent.defaultProps = {
  result: {},
};

export default PropertiesPageHouseRent;
